import React from "react";

import { Grid } from "@material-ui/core";
import OverallRetailersAlignmentScore from "./OverallRetailersAlignmentScore";
import RetailersAlignment from "./RetailersAlignment";
import RetailZoneCharacteristics from "./RetailZoneCharacteristics";

const AlignmentToRetailersTarget: React.FC = () => {
    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <RetailersAlignment />
            </Grid>
            <Grid item xs={12}>
                <OverallRetailersAlignmentScore />
            </Grid>
            <Grid item xs={12}>
                <RetailZoneCharacteristics />
            </Grid>
        </Grid>
    );
};

export default AlignmentToRetailersTarget;
